const ACCESS_KEYS = {
  general: "7e190079-8dbf-4a53-a01a-9091de5c72ed",
  "report-error": "94d3d064-1109-40fb-89d6-e7f00cc6ab3f",
  "missing-root": "9b407b40-5636-4a36-ac29-b0e2dd302c21",
};

export const submitFeedback = async (mode, fields) => {
  const res = await fetch("https://api.web3forms.com/submit", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ access_key: ACCESS_KEYS[mode], ...fields }),
  });
  const data = await res.json();
  if (!res.ok || !data.success) throw new Error(data.message || "Submission failed");
  return data;
};
